import { RootState } from "@/store/store";
import { normalizedCostWidgetSetupSelector } from "@/store/dashboards/selectors/setups/normalized-cost-widget/normalizedCostWidgetSetupSelector";

export const normalizedCostWidgetSetupIdSelector = (state: RootState) => {
  return normalizedCostWidgetSetupSelector(state)?.id;
};
